import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PatientProvider } from '../../models/patient-details.model';

@Component({
  selector: 'app-patient-providers',
  templateUrl: './patient-providers.component.html',
  styleUrls: ['./patient-providers.component.scss'],
  standalone: false
})
export class PatientProvidersComponent implements OnInit, OnChanges {
  @Input() providers: PatientProvider[] = [];

  activeProviders: PatientProvider[] = [];

  ngOnInit(): void {
    this.filterActiveProviders();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['providers']) {
      this.filterActiveProviders();
    }
  }

  private filterActiveProviders(): void {
    if (this.providers && Array.isArray(this.providers)) {
      this.activeProviders = this.providers.filter((p) => p && p.inActiveFlag === false);
    } else {
      this.activeProviders = [];
    }
  }
}